import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeFourComponent } from './components/pages/home/home.component';
import { AboutComponent } from './components/pages/about-us/about-us.component';
import { TeamComponent } from './components/pages/team/team.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { LogInComponent } from './components/pages/log-in/log-in.component';
// import { SignUpComponent } from './components/pages/sign-up/sign-up.component';
import { RecoverPasswordComponent } from './components/pages/recover-password/recover-password.component';
import { TermsConditionsComponent } from './components/pages/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './components/pages/cookies-policy/cookies-policy.component';

import { ContactComponent } from './components/pages/contact/contact.component';
import { NewsDetailsComponent } from './components/pages/news/news-details/news-details.component';
import { NewsRightSidebarComponent } from './components/pages/news/news-right-sidebar/news-right-sidebar.component';

import { DedicatedHostingComponent } from './components/pages/services/dedicated-hosting/dedicated-hosting.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ClientsComponent } from './components/pages/general/clients/clients.component';
import { ClientsSaysComponent } from './components/pages/general/clients-says/clients-says.component';
import { ContactFormComponent } from './components/pages/general/contact-form/contact-form.component';
import { SitesAreaComponent } from './components/pages/general/sites-area/sites-area.component';
import { LatestNewsComponent } from './components/pages/general/latest-news/latest-news.component';
import { NoAuthComponent } from './components/pages/no-auth/no-auth.component';
import { RoleGuard } from './auth.guard';
import { PanelLayoutComponent } from './components/panel/layouts/panel-layout.component';
import { PanelDashboardComponent } from './components/panel/dashboard/dashboard.component';
import { PanelProfileComponent } from './components/panel/profile/profile.component';
import { PanelPaymentMethodsComponent } from './components/panel/payment-methods/payment-methods.component';
import { PanelServicesComponent } from './components/panel/services/services.component';

import { ServiceDirectoryComponent } from './components/pages/services/services-directory/services-directory.component';
import { CloudComputingComponent } from './components/pages/services/cloud-computing/cloud-computing.component';
import { CloudStorageComponent } from './components/pages/services/cloud-storage/cloud-storage.component';
import { EquipmentAdministrationComponent } from './components/pages/services/equipment-administration/equipment-administration.component';
import { GamingServersComponent } from './components/pages/services/gaming-servers/gaming-servers.component';
import { IntermediateDataProtectionComponent } from './components/pages/services/intermediate-data-protection/intermediate-data-protection.component';
import { DedicatedDatabaseComponent } from './components/pages/services/dedicated-database/dedicated-database.component';



const routes: Routes = [
    { path: '', component: HomeFourComponent },
    { path: 'team', component: TeamComponent },
    {
        path: 'faq', component: FaqComponent
    },

    { path: 'recover-password', component: RecoverPasswordComponent },
    { path: 'terms-conditions', component: TermsConditionsComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'cookies-policy', component: CookiesPolicyComponent},


    { path: 'services/directory', component: ServiceDirectoryComponent },
    { path: 'services/cloud-computing', component: CloudComputingComponent },
    { path: 'services/cloud-storage', component: CloudStorageComponent },
    { path: 'services/dedicated-hosting', component: DedicatedHostingComponent },
    { path: 'services/equipment-administration', component: EquipmentAdministrationComponent },
    { path: 'services/gaming-servers', component: GamingServersComponent },
    { path: 'services/intermediate-data-protection', component: IntermediateDataProtectionComponent },
    { path: 'services/dedicated-database', component: DedicatedDatabaseComponent },
    { path: 'log-in', component: LogInComponent },


    { path: 'about-us', component: AboutComponent },
    { path: 'news', component: NewsRightSidebarComponent },
    { path: 'news/view/:id', component: NewsDetailsComponent },
    { path: 'news-details', component: NewsDetailsComponent },
    { path: 'coming-soon', component: ComingSoonComponent },
    { path: 'error', component: ErrorComponent },
    { path: 'contact', component: ContactComponent },
    { path: 'clients', component: ClientsComponent },
    { path: 'clients-says', component: ClientsSaysComponent },
    { path: 'contact-form', component: ContactFormComponent },
    { path: 'sites-area', component: SitesAreaComponent },
    { path: 'latest-area', component: LatestNewsComponent },
    { path: 'unauthorized', component: NoAuthComponent },
    {
        path: 'panel',
        component: PanelLayoutComponent,
        children: [
            {
                path: 'dashboard', component: PanelDashboardComponent,
                canActivate: [RoleGuard],
                data: { roles: ['Admin', 'Manager', 'Client'] }
            },
            {
                path: 'services', component: PanelServicesComponent,
                canActivate: [RoleGuard],
                data: { roles: ['Admin', 'Manager', 'Client'] }
            },
            {
                path: 'payment-methods', component: PanelPaymentMethodsComponent,
                canActivate: [RoleGuard],
                data: { roles: ['Admin', 'Manager', 'Client'] }
            },
            {
                path: 'profile', component: PanelProfileComponent, canActivate: [RoleGuard],
                data: { roles: ['Admin', 'Manager', 'Client'] }
            },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        ],
    },


    { path: '**', component: ErrorComponent } // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }